export enum Environments {
    REACT_APP_PORTAL_CLIENTE_API_HOST = "https://api.cashgo.com.br/portal-cliente-api",
    REACT_APP_PORTAL_CLIENTE_API_HOST_DEV = "https://dev-api.cashgo.com.br/portal-cliente-api",
    REACT_APP_PORTAL_CLIENTE_API_HOST_LOCAL = "http://localhost:3002/portal-cliente-api",

    REGION = "us-east-1",
}